<div class="buttons-container">
  <ng-content select="[slot=buttons-content]"></ng-content>
</div>
